// Central data for the Messinger marketing site.

export const COMPANY = {
  name: "KFZ-Sachverständigenbüro Messinger",
  owner: "Mike Messinger",
  role: "KFZ-Sachverständiger & KFZ-Meister",
  tagline:
    "Vertrauen durch Expertise: Ihr Partner für KFZ-Gutachten und Fahrzeugbewertungen",
  city: "Castrop-Rauxel",
  address: {
    street: "Mozartstraße 2",
    zip: "44575",
    city: "Castrop-Rauxel",
  },
  phone: "+49 0000 0000000",
  phoneHref: "tel:+490000000000",
  whatsapp: "+49 0000 0000000",
  whatsappHref: "https://wa.me/490000000000",
  email: "info@messinger-gutachten.de",
  emailHref: "mailto:info@messinger-gutachten.de",
};

export const SERVICE_AREA = [
  "Castrop-Rauxel",
  "Dortmund",
  "Herne",
  "Recklinghausen",
  "Bottrop",
  "Gelsenkirchen",
  "Witten",
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_d6ba3cdd-f2e2-4828-997f-9e187f028b84/artifacts/peu2bz05_LOGO_MESSINGER_KFZ_SACHVERST%C3%84NDIGER_Castrop-Rauxel_Autounfall_Kfz-Gutachter_Recklinghausen_Herne_Gelsenkirchen_Witten_Dortmund_Gutachten-1920w-removebg-preview.png";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxjYXIlMjBkYXJrJTIwZ2FyYWdlfGVufDB8fHx8MTc4MTUyNjA4OHww&ixlib=rb-4.1.0&q=85";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1486006920555-c77dcf18193c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200";

export const TESTIMONIALS_BG =
  "https://images.unsplash.com/photo-1643701079732-3b1c7a797e3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxtZWNoYW5pYyUyMGhvbGRpbmclMjB0YWJsZXR8ZW58MHx8fHwxNzgxNTI2MDk0fDA&ixlib=rb-4.1.0&q=85";

export const SERVICES = [
  {
    slug: "kfz-schadengutachten",
    title: "KFZ-Schadengutachten / Unfallgutachten",
    short:
      "Nach dem Unfall: unabhängiges Gutachten mit beweissicherer Dokumentation, Wiederbeschaffungswert und Restwert.",
    icon: "ShieldAlert",
    image:
      "https://images.unsplash.com/photo-1662541547523-118842914aa7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxjYXIlMjBkYW1hZ2UlMjBkZW50fGVufDB8fHx8MTc4MTUyNjA4OHww&ixlib=rb-4.1.0&q=85",
    intro:
      "Sie hatten einen Unfall? Als unabhängiger KFZ-Sachverständiger erstelle ich ein gerichtsverwertbares Schadengutachten — neutral, präzise und schnell. Damit erhalten Sie eine objektive Grundlage für die Regulierung mit der Versicherung.",
    steps: [
      { title: "Erstkontakt", text: "Anruf, WhatsApp oder Formular — Termin innerhalb von 24 Std." },
      { title: "Fahrzeugbesichtigung", text: "Vor Ort oder in der Werkstatt, beweissichere Foto- und Messprotokolle." },
      { title: "Bewertung", text: "Schadenshöhe, Wiederbeschaffungswert, Restwert, Wertminderung." },
      { title: "Gutachten", text: "Schriftliches Gutachten innerhalb weniger Werktage, direkt nutzbar bei der Versicherung." },
    ],
  },
  {
    slug: "young-oldtimerbewertung",
    title: "Young- & Oldtimerbewertung",
    short:
      "Marktwertgutachten für Liebhaberfahrzeuge — fundierte Bewertung nach Zustandsnoten und aktuellen Marktpreisen.",
    icon: "Car",
    image:
      "https://images.unsplash.com/photo-1532751203793-812308a10d8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxjbGFzc2ljJTIwY2FyJTIwdmludGFnZXxlbnwwfHx8fDE3ODE1MjYwODh8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "Klassische Fahrzeuge brauchen einen klassischen Blick. Ich bewerte Young- und Oldtimer nach den anerkannten Zustandsnoten 1 – 5 und liefere Ihnen ein aussagekräftiges Marktwertgutachten — für Versicherung, Verkauf oder die eigene Sammlung.",
    steps: [
      { title: "Vorbereitung", text: "Fahrzeughistorie, Restaurierungsunterlagen, Service-Heft sichten." },
      { title: "Begutachtung", text: "Detaillierte Sichtprüfung von Karosserie, Technik, Innenraum, Originalität." },
      { title: "Marktanalyse", text: "Abgleich mit aktuellen Marktpreisen und Auktionsergebnissen." },
      { title: "Wertgutachten", text: "Übergabe inkl. Marktwert, Wiederbeschaffungswert und Zustandsnote." },
    ],
  },
  {
    slug: "kfz-wertgutachten",
    title: "KFZ-Wertgutachten",
    short:
      "Fundierte Wertermittlung für Kauf, Verkauf, Versicherung oder Vermögensaufteilung.",
    icon: "BadgeEuro",
    image:
      "https://images.unsplash.com/photo-1643700973089-baa86a1ab9ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxtZWNoYW5pYyUyMGhvbGRpbmclMjB0YWJsZXR8ZW58MHx8fHwxNzgxNTI2MDk0fDA&ixlib=rb-4.1.0&q=85",
    intro:
      "Ein neutrales Wertgutachten schafft Klarheit — beim Verkauf, bei der Versicherung oder im Erb- und Scheidungsfall. Ich ermittle den aktuellen Marktwert Ihres Fahrzeugs objektiv und nachvollziehbar.",
    steps: [
      { title: "Termin", text: "Schnelle Terminvergabe — auf Wunsch bei Ihnen vor Ort." },
      { title: "Fahrzeugaufnahme", text: "Vollständige Dokumentation aller relevanten Merkmale." },
      { title: "Marktrecherche", text: "Vergleich mit aktuellen Angeboten und Verkaufspreisen." },
      { title: "Wertgutachten", text: "Schriftliches Gutachten mit klar belegtem Marktwert." },
    ],
  },
  {
    slug: "kfz-beweissicherung",
    title: "KFZ-Beweissicherung",
    short:
      "Vorab-Dokumentation von Fahrzeugzustand, Schäden oder Mängeln — beweissicher und gerichtsverwertbar.",
    icon: "ScanLine",
    image:
      "https://images.unsplash.com/photo-1606577924006-27d39b132ae2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxjYXIlMjBlbmdpbmUlMjByZXBhaXJ8ZW58MHx8fHwxNzgxNTI2MDk1fDA&ixlib=rb-4.1.0&q=85",
    intro:
      "Ob bei Leasingrückgabe, Werkstattstreit oder Vorab-Bewertung: Eine professionelle Beweissicherung schützt Ihre Rechte. Ich dokumentiere den Fahrzeugzustand fotografisch und schriftlich — neutral und gerichtsverwertbar.",
    steps: [
      { title: "Auftrag", text: "Sie schildern Ihr Anliegen, ich erkläre Ablauf und Aufwand transparent." },
      { title: "Dokumentation", text: "Strukturierte Foto-, Mess- und Zustandsaufnahme." },
      { title: "Auswertung", text: "Befundbericht mit eindeutigen Aussagen, ohne Spielraum für Interpretationen." },
      { title: "Übergabe", text: "Digitales Dossier — bereit für Anwalt, Gericht oder Versicherung." },
    ],
  },
  {
    slug: "kfz-kostenvoranschlaege",
    title: "KFZ-Kostenvoranschläge",
    short:
      "Unabhängige Kostenvoranschläge für Reparaturen — transparent, nachvollziehbar, ohne Werkstattbindung.",
    icon: "ClipboardList",
    image:
      "https://images.unsplash.com/photo-1631856507219-d1f3465b4884?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxjYXIlMjBoZWFkbGlnaHQlMjByZXBhaXJ8ZW58MHx8fHwxNzgxNTI2MDk1fDA&ixlib=rb-4.1.0&q=85",
    intro:
      "Sie wollen wissen, was die Reparatur wirklich kostet? Ich erstelle einen unabhängigen Kostenvoranschlag auf Basis aktueller Stundenverrechnungssätze und Ersatzteilpreise — ohne Eigeninteresse an einer Werkstatt.",
    steps: [
      { title: "Schadenaufnahme", text: "Detaillierte Analyse aller betroffenen Bauteile." },
      { title: "Kalkulation", text: "Kalkulation nach DAT/Audatex inkl. Lackier- und Arbeitswerten." },
      { title: "Prüfung", text: "Plausibilitätscheck — alles im realistischen Rahmen, nichts geschönt." },
      { title: "Kostenvoranschlag", text: "Übersichtliches PDF — verständlich für Sie und Versicherung." },
    ],
  },
  {
    slug: "reparaturbestaetigung",
    title: "Reparaturbestätigung",
    short:
      "Fachliche Bestätigung der ordnungsgemäßen Reparatur — wichtig für Wertgutachten und Wiederverkauf.",
    icon: "CheckCircle2",
    image:
      "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxjYXIlMjBlbmdpbmUlMjByZXBhaXJ8ZW58MHx8fHwxNzgxNTI2MDk1fDA&ixlib=rb-4.1.0&q=85",
    intro:
      "Wurde Ihr Fahrzeug nach einem Unfall in Eigenregie repariert? Mit einer fachlichen Reparaturbestätigung weisen Sie nach, dass die Arbeiten ordnungsgemäß erfolgt sind — wichtig für Wiederverkauf und Versicherung.",
    steps: [
      { title: "Termin", text: "Kurzfristige Vor-Ort-Termine möglich." },
      { title: "Sichtprüfung", text: "Prüfung der reparierten Bauteile auf Fachgerechtigkeit." },
      { title: "Foto-Dokumentation", text: "Beweissichere Dokumentation des Endzustands." },
      { title: "Bestätigung", text: "Schriftliche Reparaturbestätigung als PDF." },
    ],
  },
];

export const STATS = [
  { value: 20, suffix: "+", label: "Jahre Erfahrung" },
  { value: 4800, suffix: "+", label: "Gutachten erstellt" },
  { value: 7, suffix: "", label: "Städte im Einzugsgebiet" },
  { value: 24, suffix: "h", label: "Reaktionszeit" },
];

export const TESTIMONIALS = [
  {
    name: "Ivonne H.",
    location: "Castrop-Rauxel",
    text:
      "Nach unserem Unfall waren wir komplett überfordert. Herr Messinger hat uns ruhig durch den gesamten Prozess geführt — schnell, freundlich und absolut kompetent. Das Gutachten wurde von der Versicherung ohne Diskussion akzeptiert.",
  },
  {
    name: "Mark S.",
    location: "Dortmund",
    text:
      "Ich habe meinen Oldtimer durch Herrn Messinger bewerten lassen. Sehr fachkundig, mit einem echten Auge fürs Detail. Die Bewertung war fundiert und für die Versicherung sofort verwendbar. Klare Empfehlung.",
  },
  {
    name: "Bastian K.",
    location: "Recklinghausen",
    text:
      "Persönlich, transparent, schnell. Der Termin kam kurzfristig zustande, das Gutachten war zwei Tage später fertig. So stelle ich mir guten Service vor.",
  },
];

export const FAQS = [
  {
    q: "Was kostet ein Gutachten?",
    a: "Bei einem unverschuldeten Unfall trägt in der Regel die gegnerische Versicherung die Kosten — für Sie entstehen also keine Kosten. Bei Wert- oder Oldtimergutachten richten sich die Kosten nach Aufwand und Fahrzeugwert. Sie erhalten vorab ein transparentes, schriftliches Angebot.",
  },
  {
    q: "Wer zahlt die Kosten nach einem Unfall?",
    a: "Bei unverschuldeten Unfällen übernimmt die Haftpflichtversicherung des Unfallverursachers die Sachverständigenkosten in voller Höhe. Sie haben das Recht auf einen unabhängigen Sachverständigen Ihrer Wahl.",
  },
  {
    q: "Wie schnell bekomme ich einen Termin?",
    a: "In der Regel innerhalb von 24 Stunden — auch am Wochenende erreichen Sie mich per WhatsApp. Termine finden vor Ort, in der Werkstatt oder bei mir im Büro in Castrop-Rauxel statt.",
  },
  {
    q: "Kann der Sachverständige selbst gewählt werden?",
    a: "Ja. Nach einem unverschuldeten Unfall haben Sie das Recht, einen unabhängigen Sachverständigen frei zu wählen. Lassen Sie sich von der gegnerischen Versicherung nicht dazu drängen, deren Gutachter zu nehmen.",
  },
  {
    q: "Oldtimer-Bewertung — was wird benötigt?",
    a: "Idealerweise bringen Sie Fahrzeugpapiere, Servicehistorie, Restaurierungsdokumentation und ggf. frühere Gutachten mit. Vor Ort prüfe ich Karosserie, Technik, Innenraum und Originalität — der Rest läuft transparent über die anerkannten Zustandsnoten.",
  },
  {
    q: "In welchem Umkreis sind Sie tätig?",
    a: "Mein Einzugsgebiet umfasst Castrop-Rauxel, Dortmund, Herne, Recklinghausen, Bottrop, Gelsenkirchen und Witten. Termine in angrenzenden Städten nach Absprache.",
  },
];

export const VALUES = [
  {
    title: "Vertrauen",
    text: "Direkter Kontakt, klare Worte, keine versteckten Kosten — Sie wissen jederzeit, woran Sie sind.",
  },
  {
    title: "Kompetenz",
    text: "KFZ-Meister und Sachverständiger in einer Person — fundiertes Handwerk trifft präzise Gutachtenerstellung.",
  },
  {
    title: "Transparenz",
    text: "Beweissichere Dokumentation, nachvollziehbare Bewertung, verständliche Sprache — auch ohne Werkstatt-Vokabular.",
  },
];
